import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { SubTabs } from 'shared/components';
import BILLING_NOTE_STATUS_QUERY, {
  BillingNoteStatusData,
} from 'shared/graphql/query/billingNoteStatus';
import { BillingNotesStatus } from 'views/AccountReceive/common/model/billingNoteStatus.model';

interface BillingNoteTabsProps {
  name: string;
  tab: BillingNotesStatus;
  onChange: (tab: BillingNotesStatus) => void;
}

const BillingNoteTabs: React.FC<BillingNoteTabsProps> = (props) => {
  const { tab, onChange, name } = props;
  const { data, refetch } = useQuery<BillingNoteStatusData>(BILLING_NOTE_STATUS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const checkSelectTab = (id: BillingNotesStatus) => {
    return id === tab && name === 'billingNote';
  };

  const selectTab = (index: BillingNotesStatus) => {
    refetch();
    onChange(index);
  };

  const tabs = [
    {
      id: BillingNotesStatus.BILLING_NOTE,
      name: 'รอรับชำระ',
      color: 'badge-grey',
      count: data?.billingNoteStatus.billing_note || 0,
    },
    {
      id: BillingNotesStatus.COMPLETED,
      name: 'ปิดบิลแล้ว',
      color: 'badge-grey',
      count: data?.billingNoteStatus.completed || 0,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
  }));

  return <SubTabs tabs={tabs} />;
};

export default BillingNoteTabs;
